/**
 * The error a failed API call throws once it is inside TanStack Query.
 *
 * Kept in its own module (rather than alongside `useApiQuery`) so
 * `queryClient.ts` can import it without pulling in React hooks.
 */
export class ApiError extends Error {
  readonly status: number;
  /** False for expected empty states — the inline message renders, no toast.
   *  Comes straight from `apiErrorInfo`'s `toast` flag. */
  readonly shouldToast: boolean;

  constructor(message: string, status: number, shouldToast: boolean) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.shouldToast = shouldToast;
  }
}

/** The message a hook should render for a failed query, or null when it
 *  succeeded. Every migrated hook returns exactly this as its `error`. */
export function errorMessage(error: unknown): string | null {
  if (!error) return null;
  return error instanceof Error ? error.message : "Unexpected error occurred";
}
